if (!customElements.get('product-form')) {
  class ProductForm extends window.BaseComponent {
    constructor() {
      super();
      this._onSubmit = this.onSubmitHandler.bind(this);
      this._submitting = false;
    }

    init() {
      this.form = this.querySelector('form');
      // Remove any previous listener before adding (prevents duplicates on re-init)
      this.form.removeEventListener('submit', this._onSubmit);
      this.form.addEventListener('submit', this._onSubmit);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this._submitting) return;

      const submitButton = this.querySelector('[name="add"]');
      if (!submitButton || submitButton.classList.contains('loading')) return;

      this._submitting = true;
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(this.form)
      };

      fetch(`${window.routes.cart_add_url}.js`, config)
        .then((response) => {
          if (response.status === 429) {
            throw { type: 'rate-limit', status: 429 };
          }
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // Success — fetch cart totals for header count update.
          // Delay slightly to let Shopify's dynamic checkout SDK finish
          // its own /cart.js refetch first, avoiding 429 rate limits.
          if (window.pubsub) {
            this._fetchCartForPubsub();
          }
        })
        .catch((e) => {
          if (e && e.type === 'rate-limit') {
            console.warn('Add to cart rate-limited. Retrying in 2s...');
            setTimeout(() => {
              this._submitting = false;
              submitButton.removeAttribute('disabled');
              submitButton.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
              // Re-submit automatically
              this.onSubmitHandler(evt);
            }, 2000);
            return;
          }
          console.error('Add to cart error:', e);
        })
        .finally(() => {
          this._submitting = false;
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    _fetchCartForPubsub(retryCount) {
      retryCount = retryCount || 0;

      // Wait 1.5s before fetching to let Shopify's checkout SDK settle
      setTimeout(() => {
        fetch(`${window.routes.cart_url}.js`)
          .then(res => {
            if (res.status === 429) {
              throw { type: 'rate-limit' };
            }
            return res.json();
          })
          .then(cart => {
            window.pubsub.publish('cart-update', cart);
          })
          .catch(err => {
            if (err && err.type === 'rate-limit' && retryCount < 2) {
              const backoff = Math.pow(2, retryCount + 1) * 1000;
              console.warn(`Cart fetch rate-limited. Retry ${retryCount + 1}/2 in ${backoff / 1000}s...`);
              setTimeout(() => this._fetchCartForPubsub(retryCount + 1), backoff);
            }
          });
      }, 1500);
    }

    handleErrorMessage(errorMessage) {
      console.error(errorMessage);
      alert(errorMessage);
    }
  }

  if (window.BaseComponent) {
    customElements.define('product-form', ProductForm);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.BaseComponent) customElements.define('product-form', ProductForm);
    });
  }
}

